import { ToastContainer } from 'react-toastify'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import {
  Container,
  Div,
  DivTablePaginacao,
  TitleTable,
  WrapperCards,
  WrapperTable,
  WrapperTop,
} from './DashBoard.style'
import { ButtonCardStyle } from '../../components/TableSection/TableSection.style'
import { colors } from '../../theme'
import { EveryUser } from '../../assets/icons/every-user'
import { ChevronRight } from '../../assets/icons/chevron right'
import { FacialBlueIcon } from '../../assets/icons/FacialBlue'
import { Loading } from '../../components/Loading/Loading'
import { useDashboard } from './useDashboard'
import { Tour } from '../../components/Tour'
import TourDashboard from '../../utils/JoyRide/tourDashboard'
import Tooltips from '../../components/Tooltip'
import { usePrediction } from '../Predictions/usePrediction'
import { PaginationHistoryPredict } from '../../components/Pagination/Pagination'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { ButtonCard } from '../../components/ButtonCard/ButtonCard'

export function Dashboard() {
  const { dataHoje } = usePrediction()
  localStorage.setItem('dataInicio', JSON.stringify(dataHoje))
  const {
    product,
    client,
    dashboardResume,
    isLoading,
    isLoadingProducts,
    isLoadingClients,
    goToPageProducts,
    goToPageClient,
    changeStateClients,
    changeStateProducts,
    isOnHighProducts,
    isOnHighClients,
    currentPagePruduct,
    setCurrentPageProduct,
    currentPageClient,
    setCurrentPageClient,
  } = useDashboard()

  return (
    <>
      <ToastContainer theme="dark" />
      <Container id="dashboard">
        <WrapperTop id="finalizacao">
          Dashboard
          <Tooltips icon={<Tour steps={TourDashboard} />} text="Tour" />
        </WrapperTop>
        {isLoading ? (
          <Loading contrast />
        ) : (
          <WrapperCards id="saudacao">
            <CardDashboard
              colorTitle={colors.white}
              color={colors.white}
              background={colors.surfaceHigh}
              total={dashboardResume?.quantidadeProdutosAlta}
              percentage={dashboardResume?.percentualVariacaoProdutosAlta}
              percentageGraphic={dashboardResume?.percentualTotalProdutosAlta}
            >
              Total <strong>produtos</strong> em alta
            </CardDashboard>
            <CardDashboard
              colorTitle={colors.white}
              color={colors.white}
              background={colors.surfaceHigh}
              total={dashboardResume?.quantidadeProdutosBaixa}
              percentage={dashboardResume?.percentualVariacaoProdutosBaixa}
              percentageGraphic={dashboardResume?.percentualTotalProdutosBaixa}
            >
              Total <strong>produtos</strong> em baixa
            </CardDashboard>
            <CardDashboard
              colorTitle={colors.white}
              color={colors.white}
              background={colors.surfaceHigh}
              total={dashboardResume?.quantidadeClientesAlta}
              percentage={dashboardResume?.percentualVariacaoClientesAlta}
              percentageGraphic={dashboardResume?.percentualTotalClientesAlta}
            >
              Total <strong>cliente</strong> em alta
            </CardDashboard>
            <CardDashboard
              colorTitle={colors.white}
              color={colors.white}
              background={colors.surfaceHigh}
              total={dashboardResume?.quantidadeClientesBaixa}
              percentage={dashboardResume?.percentualVariacaoClientesBaixa}
              percentageGraphic={dashboardResume?.percentualTotalProdutosBaixa}
            >
              Total <strong>cliente</strong> em baixa
            </CardDashboard>
          </WrapperCards>
        )}
      </Container>
      <Div id="table">
        <WrapperTable>
          <DivTablePaginacao>
            <TitleTable>
              <CardIconTitle
                icon={<FacialBlueIcon />}
                background={colors.grey200}
                title="Produtos"
              />
              <ButtonCardStyle onClick={() => setCurrentPageProduct(1)}>
                <ButtonCard
                  isOnHigh={isOnHighProducts}
                  changeValue={changeStateProducts}
                />
              </ButtonCardStyle>
            </TitleTable>
            <GenericTable
              font="14px"
              spacing="20px"
              headers={['Produto', 'Percentual', 'Qtd.']}
              title4
            >
              {isLoadingProducts ? (
                <Loading contrast={false} />
              ) : (
                product &&
                Array.isArray(product.content) &&
                product.content.map(item => (
                  <tr
                    id="itemProduto"
                    className="itemTable"
                    onClick={() => goToPageProducts(item.id)}
                    key={item.id}
                  >
                    <td className="col2">{item.nome}</td>
                    <td className="col3">
                      {String(item.percentual).replace('.', ',')}%
                    </td>
                    <td className="colIcon">
                      <ChevronRight />
                    </td>
                  </tr>
                ))
              )}
            </GenericTable>
          </DivTablePaginacao>
          <PaginationHistoryPredict
            marginBottom="0px"
            pageNumber={currentPagePruduct}
            pageSize={product.totalElements}
            offSet={product.size}
            onClick={page => setCurrentPageProduct(page)}
          />
        </WrapperTable>
        <WrapperTable>
          <DivTablePaginacao>
            <TitleTable>
              <CardIconTitle
                icon={<EveryUser />}
                background={colors.grey200}
                title="Clientes"
              />
              <ButtonCardStyle onClick={() => setCurrentPageClient(1)}>
                <ButtonCard
                  isOnHigh={isOnHighClients}
                  changeValue={changeStateClients}
                />
              </ButtonCardStyle>
            </TitleTable>
            <GenericTable
              font="14px"
              spacing="20px"
              headers={['Produto', 'Percentual', 'Qtd.']}
              title4
            >
              {isLoadingClients ? (
                <Loading contrast={false} />
              ) : (
                client &&
                Array.isArray(client.content) &&
                client.content.map(item => (
                  <tr
                    id="itemCliente"
                    className="itemTable"
                    onClick={() => goToPageClient(item.id)}
                    key={item.id}
                  >
                    <td className="col2">{item.nome}</td>
                    <td className="col3">
                      {String(item.percentual).replace('.', ',')}%
                    </td>
                    <td className="colIcon">
                      <ChevronRight />
                    </td>
                  </tr>
                ))
              )}
            </GenericTable>
          </DivTablePaginacao>
          <PaginationHistoryPredict
            marginBottom="0px"
            pageNumber={currentPageClient}
            pageSize={client.totalElements}
            offSet={client.size}
            onClick={page => setCurrentPageClient(page)}
          />
        </WrapperTable>
      </Div>
    </>
  )
}
